'use strict';

import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import cn from 'classnames/bind';

import { appSelectors, appOperations } from '@/state/domains/app';
import { locationListSelectors, locationListOperations } from '@/state/domains/locationList';

//import s from './styles.scss';
import m from '../styles.scss';

export default connect(
	(state, props) => ({
		modals: appSelectors.getModalStates(state, props),
		date: appSelectors.getPageDate(state, props),
		username: appSelectors.getPageUsername(state, props),
		selectedIndices: locationListSelectors.getSelectedIndices(state, props),
	}),
	{
		setModalClose: appOperations.setModalClose,
		postDeleteLocations: locationListOperations.postDeleteLocations,
	}
)(
	({
		modals,
		date,
		username,
		selectedIndices,
		postDeleteLocations,
		setModalClose
	}) => {

		const deleteLocations = () => {

			postDeleteLocations(username, date, selectedIndices);
			setModalClose('deleteJobs');
		};

		return (
			<Modal
				appElement={ document.getElementById('root') }
				overlayClassName={ m.modalOverlay }
				isOpen={ modals.deleteJobs }
				contentLabel='Confirm Delete'
				shouldCloseOnOverlayClick={ true }
				shouldCloseOnEsc={ true }
				onRequestClose={ () => setModalClose('deleteJobs') }
				className={ m.modal }
			>
				<p>Delete from route</p>
				<div className={ m.btns }>
					<button
						onClick={ () => setModalClose('deleteJobs') }
						className={ m.cancel }
					>
						Cancel
					</button>
					<button
						onClick={ deleteLocations }
						className={ m.proceed }
					>
						Delete
					</button>
				</div>
			</Modal>
		);
	}
);
